import { Dispatch, SetStateAction } from 'react';

export enum Step {
  ADD_CARD_FORM = 'add-card-form',
  CARD_SUMMARY = 'card-summary',
  CHECK_BALANCE = 'check-balance',
}

export type GiftCardActionSheetProps = {
  headerTitle: string;
  isVisible: boolean;
  isLoadingGiftCard?: boolean;
  isCheckBalanceFlow?: boolean;
  currentStep?: Step;
  currentDigitalBalance?: number;
  handleBalanceUpdate?: (newBalance: number) => void;
  handleError?: () => void;
  setCurrentStep: Dispatch<SetStateAction<Step>>;
  onClose?: () => void;
  onGiftCardSaved?: () => void;
  // Form state (managed by parent hook)
  cardId: string;
  onCardIdChange: (cardId: string) => void;
  pin: string;
  onPinChange: (pin: string) => void;
};

export type StepAddCardFormProps = {
  cardId: string;
  onCardIdChange: (cardId: string) => void;
  pin: string;
  onPinChange: (pin: string) => void;
  isLoadingGiftCard: boolean;
  onContinue: () => void;
  errorMessage?: string;
};

export type StepCardSummaryProps = {
  cardId: string;
  balance: number;
  digitalBalance: number;
  isLoading?: boolean;
  onChangePress: () => void;
  onSave: () => void;
};

export type StepCheckBalanceProps = {
  cardId: string;
  balance: number;
  onChangePress: () => void;
  onAddToYourAccountPress: () => void;
};

export type GiftCardFormInputProps = {
  cardId: string;
  pin: string;
};

export type GiftCardFormInputErrors = {
  cardId?: string;
  pin?: string;
};
